<div class="container-fluid" id="contact">
    <div class="row">
        <div class="col-4 user-select-none offset-1">
            <h6 class="font-brand text-white text-uppercase" style="clear: none; display: inline">Nuestro</h6>
            <h6 style="clear: none; display: inline"> <span class="font-brand text-brand text-uppercase"> Contacto</span>
            </h6>
            <h5 class="font-brand-secondary text-white text-uppercase mt-2">Déjanos un mensaje con tus consultas!
                <!--también puedes buscarnos en redes sociales-->
            </h5>
            <div class="row mt-4">
                <div class="col-12">
                    <!--<img src="../../../../../assets/instagram.svg" alt="" width="50">
                    <img src="../../../../../assets/whatsapp.svg" alt="" width="50" class="mx-4">
                    <img src="../../../../../assets/linkedin.svg" alt="" width="50">-->
                </div>
            </div>
        </div>
        <div class="col-7">
            <div class="d-flex justify-content-center bd-highlight text-center text-white">
                <div class="col-9">
                    <form [formGroup]="form" #contactForm="ngForm" (ngSubmit)="onSubmit(contactForm)">
                        <div class="row">
                            <div class="col-6">
                                <small class="text-danger" style="text-align: left;"
                                    *ngIf="controlIsRequired('name') && contactForm.submitted">
                                    (Nombre requerido)
                                </small>
                                <input placeholder="Nombre" formControlName="name"
                                    [ngClass]="{ 'is-invalid': controlIsInvalid('name') && contactForm.submitted }"
                                    type="text" class="form-control mb-3 form-control-lg border-dark"
                                    style="background: linear-gradient(180deg, rgba(103, 82, 236, 0.5) 0%, rgba(125, 100, 236, 0.41) 100%); border-radius: 15px; color: white;">
                            </div>
                            <div class="col-6">
                                <small class="text-danger ml-2"
                                    *ngIf="controlIsRequired('email') && contactForm.submitted">
                                    (Correo requerido)
                                </small>
                                <small class="text-danger ml-2"
                                    *ngIf="controlIsInvalidEmail('email') && contactForm.submitted">
                                    (Correo inválido)
                                </small>
                                <input placeholder="Email" formControlName="email"
                                    [ngClass]="{ 'is-invalid': controlIsInvalid('email') && contactForm.submitted }"
                                    type="text" class="form-control mb-3 form-control-lg border-dark"
                                    style="background: linear-gradient(180deg, rgba(103, 82, 236, 0.5) 0%, rgba(125, 100, 236, 0.41) 100%); border-radius: 15px; color: white;">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <small class="text-danger ml-2"
                                    *ngIf="controlIsRequired('message') && contactForm.submitted">
                                    (Mensaje requerido)
                                </small>
                                <textarea placeholder="Mensaje" formControlName="message"
                                    [ngClass]="{ 'is-invalid': controlIsInvalid('message') && contactForm.submitted }"
                                    rows="5" class="form-control mb-3 form-control-lg border-dark"
                                    style="background: linear-gradient(180deg, rgba(103, 82, 236, 0.5) 0%, rgba(125, 100, 236, 0.41) 100%); border-radius: 15px; color: white; min-height: 45px;"></textarea>
                            </div>
                        </div>
                        <div class="btn-group text-center">
                            <button type="" class="btn btn-lg mt-2 btn-brand" type="submit">
                                <i class="far fa-envelope px-5"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="container-fluid">
    <div class="row justify-content-center">
        <div class="col-12">
            <div class="row justify-content-center">
                <div class="col-5 pe-0">
                    <img class="img-fluid" src="../../../../../assets/backgrounds/bg-contact.svg" alt="">
                </div>

                <div class="col-6 ps-0 user-select-none " style="max-width: 635px; margin-top:80px">
                    <h6 class="font-brand text-white text-uppercase" style="clear: none; display: inline">Conversa</h6>
                    <h6 style="clear: none; display: inline"> <span class="font-brand text-brand text-uppercase"> con
                            nosotros</span> 🙋🏾‍♀️</h6>
                    <h5 class="font-brand-secondary text-white text-uppercase mt-2">Te guiamos para que materialicemos
                        <span class="text-brand">juntos</span> tu idea.
                    </h5>
                    <button class="btn btn-sm btn-brand float-right px-4">CONTACTO</button>
                </div>
            </div>
        </div>
    </div>
</div> -->